import {convertPatternToValue} from './convertPatternToValue.js';
import KeyScaling from './KeyScaling.js';
import {convertValue} from './convertPatternToValue.js';
import Automations from './Automations.js';

export default superclass => class extends superclass  {
    fromJson(json, sequencerEngine, isCopy=false) {
        let oldId = this.id;
        if (json  === undefined) {
            return;
        }
        let bulk = {};

        if (json.id && !isCopy) {
            this.id = json.id;
            if (this.sequencerEngine) {
                this.sequencerEngine.idToParameter[this.id] = this;
            }
        }

        let subSequence = sequencerEngine !== undefined ?
            sequencerEngine.currentSubSequence || sequencerEngine.subSequences[0] : 
            undefined;

        if (json.lfo !== undefined) {
            this.enableAudioParam();
            this.connectToLFO(sequencerEngine.lfos[0].lfo);
        } else if (subSequence && json.lfos !== undefined && json.lfos.length > 0) {
            this.enableAudioParam();
            for (let i in json.lfos) {
                let lfo = json.lfos[i];
                if (this.lfos.includes(lfo)) {
                    // its already connected but id might have changed
                    lfo.replaceParameterIds(oldId, this.id, this);
                }
                this.connectToLFO(subSequence.lfos[lfo].lfo);
            }
        }

        if (subSequence && json.envelopes !== undefined && json.envelopes.length > 0) {
            this.enableAudioParam();
            json.envelopes.forEach(
                i => {
                    let env = subSequence.envelopes[i];
                    if (this.envelopes.includes(env)) {
                        env.replaceParameterIds(oldId, this.id, this);
                    } else
                    this.connectToEnvelope(env);
                });
        }

        if (json.value !== undefined) {
            bulk = this.set(json.value, true, true);
        }
        
        this.unlockedValue = json.unlockedValue !== undefined ?
            this.convertValue(json.unlockedValue) : this.value;

        if (json.patternToValue !== undefined) {
            this.patternToValue = convertPatternToValue(json.patternToValue);
        }
        if (this.isPatternLocked() && this.patternToValue[0] !== undefined) {
            bulk = this.set(this.patternToValue[0], true, true);
        } else if (this.unlockedValue !== undefined) {
            bulk = this.set(this.unlockedValue, true, true);
        }

        if (json.paletteToValue !== undefined) {
            this.paletteToValue = convertPatternToValue(json.paletteToValue);
        }

        if (json.patternToAutomation) {
            for (let i in json.patternToAutomation) {
                this.patternToAutomation[i] = new Automations(this);
                this.patternToAutomation[i].fromJson(json.patternToAutomation[i], false);
            }
            this.unlockedAutomation.fromJson(json.unlockedAutomation, false);
            if (this.isPatternLocked() && this.patternToAutomation[0]) {
                this.patternToAutomation[0].schedule();
            } else {
                this.automation.schedule();
            }
        }

        if (json.mixAutomation) {
            this.mixAutomation.fromJson(json.mixAutomation, false);
        }

        if (json.keyScaling) {
            this.keyScaling = new KeyScaling(this, json.keyScaling.min, json.keyScaling.max);
        }


        if (json.depth !== undefined) {
            if (!this.depthParameter) {
                this.initDepth();
            }
            this.depthParameter.fromJson(json.depth, sequencerEngine, isCopy);
        } else if (json._depth !== undefined) {
            this._depth = json._depth;
        }

        this.loadModsFromJson(json);

        let b = {};
        if (bulk === undefined) {
            return b;
        }
        b[bulk.id] = bulk.value;

        if (json.min !== undefined) {
            this.min = json.min;
        }

        if (json.max !== undefined) {
            this.max = json.max;
        }

        if (json.stepToValue) {
            this.stepToValue = json.stepToValue;
        }

        if (json.hide) {
            this.hide = json.hide;
        }

        return b;
   }

    convertValue(v) {
        return convertValue(v);
    }

    getPresetValue() {
        if (this.currentPattern in this.patternToValue) {
            return this.patternToValue[this.currentPattern];
        }
        return this.unlockedValue;
    }

    getJson(isPreset=false) {
        let lfos = [];
        let envelopes = [];
        let mods = this.parameterMods;
        let subSequence = this.context === undefined ? undefined : this.context.subSequence;
        let patternToAutomation = undefined;
        if (this.hasAnyAutomation()) {
            patternToAutomation = {};
            for (let i in this.patternToAutomation) {
                patternToAutomation[i] = this.patternToAutomation[i].getJson();
            }
        }
        let unlockedAutomation = undefined;
        if (this.unlockedAutomation.automations.length > 0) {
            unlockedAutomation= this.unlockedAutomation.getJson();
        }
        let mixAutomation = undefined;
        if (this.mixAutomation.automations.length > 0) {
            mixAutomation = this.mixAutomation.getJson();
        }
        let patternToValue = undefined;
        if (!isPreset && Object.keys(this.patternToValue).length > 0) {
            patternToValue = this.patternToValue;
        }
        let stepToValue = undefined;
        if (Object.keys(this.stepToValue).length > 0) {
            stepToValue = {... this.stepToValue};
        }
        let json = {
            id: this.id,
            patternToAutomation,
            unlockedAutomation,
            mixAutomation,
            // context: this.context === undefined ? undefined : this.context.getJson(),
            // subSequence: subSequence === undefined ? undefined: subSequence.id,
            // name: this.name,
            min: this.min !== this.originalMin ? this.min : undefined,
            max: this.max !== this.originalMax ? this.max: undefined,
            unlockedValue: isPreset ? this.getPresetValue() : this.unlockedValue,
            patternToValue,
            /*
            originalMin: this.originalMin,
            originalMax: this.originalMax,
            */
            mods: mods.length > 0 ? mods.map(mod => mod.getJson()) : undefined,
            lfos: this.lfos.length > 0 ? this.lfos.map(lfo => lfo.number - 1) : undefined,
            envelopes: this.envelopes.length > 0 ? this.envelopes.map(env => env.number - 1) : undefined,
            keyScaling: this.keyScaling ? this.keyScaling.getJson() : undefined,
            depth: this.depthParameter && this.depthParameter.getJson(isPreset),
            _depth: this._depth === 1 ? undefined : this._depth,
            stepToValue,
            hide: this.hide
        };

        /*
        let keys = ["stepToValue", "envelopes", "lfos", "mods", "keyScaling", "mixAutomation", "patternToValue", "paletteToValue", "patternToAutomation", "unlockedAutomation"];
        for (let key of keys) {
            if (key === "mixAutomation" && this.mixAutomation.automations.length === 0) {
                delete json[key];
                continue;
            }
            if (key === "unlockedAutomation" && this.unlockedAutomation.automations.length === 0) {
                delete json[key];
                continue;
            }
            if (json[key] === undefined || json[key] === null ||
                (Array.isArray(json[key]) && json[key].length === 0) ||
                (typeof json[key] === "object" && Object.keys(json[key]).length === 0)) {
                delete json[key];
            }
        }
        */
        return json;
   }
}
